module.exports = __webpack_public_path__ + "static/media/register.5a780772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register.jpg
// module id = 845
// module chunks = 0